import * as React from 'react';
import {Theme, createTheme, ThemeOptions, ThemeProvider, CssBaseline} from "@mui/material";

const themOptions: ThemeOptions = {
    palette: {
        mode: "light",
    },
    typography: {
        button: {
            textTransform: "initial"
        }
    }
};
const appTheme: Theme = createTheme(themOptions);

export default function ({children}: any) {
    return (
        <ThemeProvider theme={appTheme}>
            <CssBaseline/>
            {children}
        </ThemeProvider>
    );
};

